export default __webpack_public_path__ + "static/media/Freebooter's Straps of Crouching Calm.00dd5e51.jpg";